<template>
  <div class="home">
    <div class="ldr-text">
      <!-- <img src="/video/goLoader1.gif" class="img-fluid" alt="" /> -->
      <!--          <h1>{{ init_loader_trans }}</h1>-->
      <div>
        <!--            <img src="/video/goLoader1.gif" class="img-fluid" alt="" />-->
        <!--          <img src="/images/svg/loader.svg" class="img-fluid" alt="" />-->
        <img
          :src="loader_img"
          class="img-fluid"
          @error="imageLoadOnError"
          alt=""
        />
        <!-- <h1 v-if="tried_gif && error">{{ _T('Finding The Best Providers In Your Area...') }}</h1>-->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['_T', 'api_root_url']),
    loader_img() {
      let host_name = location.hostname
      // this cod eis not working for produciton, always taking stg url
      // let assets = this.api_root_url.indexOf('stg')
      //   ? 'dm-assets-stg'
      //   : 'dm-assets-prod'
      let assets = 'dm-assets-prod'
      let image_src = this.error
        ? '/images/svg/loader.svg'
        : 'https://s3-ap-south-1.amazonaws.com/' +
          assets +
          '/loader/' +
          host_name +
          '.png'
      if (this.error && !this.tried_gif) {
        image_src = this.tried_gif
          ? '/images/svg/loader.svg'
          : 'https://s3-ap-south-1.amazonaws.com/' +
            assets +
            '/loader/' +
            host_name +
            '.gif'
      }
      // console.log(image_src, 'image_src')
      return image_src
    },
  },
  methods: {
    imageLoadOnError() {
      this.error = true
      this.tried_gif = !this.tried_gif
    },
  },
  data() {
    return {
      error: false,
      tried_gif: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.home {
  background: $font-color;
  height: $px600;
  .ldr-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
    > div {
      margin-top: -$px60;
    }
    img,
    svg {
      width: calc(55% + (60 - 20) * ((100vw - 320px) / (1920 - 320)));
      margin-bottom: calc(20px + (50 - 20) * ((100vw - 320px) / (1920 - 320)));
      //animation: carbody 1s linear infinite;
    }
    @keyframes carbody {
      0% {
        transform: translateY(3px);
      }
      60% {
        transform: translateY(5px);
      }
      80% {
        transform: translateY(4px);
      }
    }
    h1 {
      font-size: calc(
        #{$px20} + (36 - 20) * ((100vw - #{$px320}) / (1920 - 320))
      );
      line-height: calc(
        #{$px20} + (44 - 20) * ((100vw - #{$px320}) / (1920 - 320))
      );
      color: #ffffff;
      font-weight: normal;
      margin-bottom: 0;
      text-transform: capitalize;
    }
  }
}
</style>
